import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import { ListPanel } from '@eika/link-panel';

import { SearchParams, useLinkProducer } from '@/domain/app';
import useText from '@/hooks/use-text';
import piwik from '@/piwik/piwik';

import { CreditCard, CreditCardAccount } from '@generated-types';

import { CardDetails } from './card-details/CardDetails';

type DetailsPanelItemsProps = {
    card: CreditCard;
    account: CreditCardAccount;
};

export const DetailsPanelItems = ({ card, account }: DetailsPanelItemsProps) => {
    const text = useText();
    const linkProducer = useLinkProducer();

    const link = linkProducer('CARD_TRANSACTION_PAGE')({
        [SearchParams.CARD_TYPE]: 'CREDIT',
        [SearchParams.CARD_ID]: card.id,
        [SearchParams.ACCOUNT_ID]: account.accountId,
    });

    return (
        <div>
            <ListPanel
                url={link}
                prefixContent={<Icon type={IconTypes.BEVEGELSER_24} />}
                title={text.transactionsTitle}
                icon={IconTypes.PIL_HOEYRE}
                backgroundColor="light"
                id="link-transactions"
                data-track-id={piwik.cardDetails.cardFunctionalityLinkTransaksjoner.dataTrackId}
                data-track-linkname={piwik.cardDetails.cardFunctionalityLinkTransaksjoner.dataTrackLinkname}
            />
            <CardDetails card={card} account={account} />
        </div>
    );
};
